module.exports = __webpack_public_path__ + "static/media/palig.5ea7c011.png";